/* import __COLOCATED_TEMPLATE__ from './group-selector.hbs'; */
import Component, { setComponentTemplate } from "@ember/component";
import { isEmpty } from "@ember/utils";
import $ from "jquery";
import { findRawTemplate } from "discourse-common/lib/raw-templates";
import discourseComputed, { observes, on } from "discourse-common/utils/decorators";
import I18n from "discourse-i18n";
import TEMPLATE from "./group-selector.hbs";
export default setComponentTemplate(TEMPLATE, Component.extend(dt7948.p({
  placeholder(placeholderKey) {
    return placeholderKey ? I18n.t(placeholderKey) : "";
  },
  _update() {
    if (this.canReceiveUpdates === "true") {
      this._initializeAutocomplete({
        updateData: true
      });
    }
  },
  _initializeAutocomplete(opts) {
    let selectedGroups;
    let groupNames = this.groupNames;
    $(this.element.querySelector("input")).autocomplete({
      debounced: true,
      allowAny: false,
      items: Array.isArray(groupNames) ? groupNames : isEmpty(groupNames) ? [] : [groupNames],
      single: this.single,
      fullWidthWrap: this.fullWidthWrap,
      updateData: opts && opts.updateData ? opts.updateData : false,
      onChangeItems: items => {
        selectedGroups = items;
        if (this.onChangeCallback) {
          this.onChangeCallback(this.groupNames, selectedGroups);
        } else {
          this.set("groupNames", items.join(","));
        }
      },
      transformComplete: g => {
        return g.name;
      },
      dataSource: term => {
        return this.groupFinder(term).then(groups => {
          if (!selectedGroups) {
            return groups;
          }
          return groups.filter(group => {
            return !selectedGroups.any(s => s === group.name);
          });
        });
      },
      template: findRawTemplate("group-selector-autocomplete")
    });
  }
}, [["method", "placeholder", [discourseComputed("placeholderKey")]], ["method", "_update", [observes("groupNames")]], ["method", "_initializeAutocomplete", [on("didInsertElement")]]])));